import moment from "moment";

const smallDate = date =>
  date
    ? moment
        .utc(date)
        .local()
        .format("DD/MM/YY")
    : "";

const longDate = date =>
  date
    ? moment
        .utc(date)
        .local()
        .format("DD/MM/YY HH:mm")
    : "";

const paramsDate = date =>
  date
    ? moment
        .utc(date)
        .local()
        .format("YYYY-MM-DD")
    : "";

export { smallDate, longDate, paramsDate };
